const keys = ["editions", "topics", "multimedia"];

function initJournalismEditionBrowser(browser) {
  if (browser.dataset.journalismEditionReady === "true") return;

  const options = [...browser.querySelectorAll("[data-journalism-edition-option]")];
  const statements = [...browser.querySelectorAll("[data-journalism-edition-statement]")];
  const articlePanels = [...browser.querySelectorAll("[data-journalism-edition-articles]")];
  const heading = browser.querySelector("[data-journalism-edition-heading]");
  const headingName = browser.querySelector("[data-journalism-edition-heading-name]");
  const initialKey = browser.dataset.currentEdition || options[0]?.dataset.editionKey || "";

  const activate = key => {
    const selected = options.find(option => option.dataset.editionKey === key) || options[0];
    if (!selected) return;

    const activeKey = selected.dataset.editionKey || "";
    const activeName = selected.dataset.editionName || "";
    const activeAccent = selected.dataset.editionAccent || "#cd6cb1";

    options.forEach(option => {
      const isActive = option === selected;
      option.classList.toggle("is-active", isActive);
      option.setAttribute("aria-selected", String(isActive));
    });

    statements.forEach(statement => {
      const isActive = statement.dataset.editionKey === activeKey;
      statement.hidden = !isActive;
      statement.classList.toggle("is-active", isActive);
    });

    articlePanels.forEach(panel => {
      const isActive = panel.dataset.editionKey === activeKey;
      panel.hidden = !isActive;
      panel.classList.toggle("is-active", isActive);
      if (isActive) panel.scrollTop = 0;
    });

    if (heading) heading.href = selected.dataset.editionUrl || `/editions/${activeKey}/`;
    if (headingName) headingName.textContent = activeName;
    browser.style.setProperty("--journalism-active-edition-accent", activeAccent);
    browser.dataset.activeEdition = activeKey;
  };

  options.forEach((option, index) => {
    option.addEventListener("click", () => activate(option.dataset.editionKey || ""));
    option.addEventListener("keydown", event => {
      if (event.key !== "ArrowDown" && event.key !== "ArrowUp") return;
      event.preventDefault();
      const direction = event.key === "ArrowDown" ? 1 : -1;
      const next = options[(index + direction + options.length) % options.length];
      next?.focus();
      if (next) activate(next.dataset.editionKey || "");
    });
  });

  browser.dataset.journalismEditionReady = "true";
  activate(initialKey);
}

function initJournalismPage(page) {
  if (page.dataset.journalismReady === "true") return;

  const panels = [...page.querySelectorAll("[data-journalism-panel]")];
  const tabs = [...page.querySelectorAll("[data-journalism-tab]")];
  const previous = page.querySelector("[data-journalism-previous]");
  const next = page.querySelector("[data-journalism-next]");
  let active = 0;

  const show = index => {
    active = (index + keys.length) % keys.length;
    const key = keys[active];

    panels.forEach(panel => {
      const selected = panel.dataset.journalismPanel === key;
      panel.hidden = !selected;
      panel.classList.toggle("is-active", selected);
    });

    tabs.forEach(tab => {
      const selected = tab.dataset.journalismTab === key;
      tab.classList.toggle("is-active", selected);
      tab.setAttribute("aria-selected", String(selected));
      tab.tabIndex = selected ? 0 : -1;
    });
  };

  tabs.forEach((tab, index) => tab.addEventListener("click", () => show(index)));
  previous?.addEventListener("click", () => show(active - 1));
  next?.addEventListener("click", () => show(active + 1));

  page.querySelectorAll("[data-journalism-share]").forEach(button => {
    button.addEventListener("click", async () => {
      const url = button.dataset.shareUrl || window.location.href;
      const title = button.dataset.shareTitle || document.title;
      if (navigator.share) {
        try { await navigator.share({ title, url }); } catch (error) { /* dismissed */ }
      } else if (navigator.clipboard) {
        await navigator.clipboard.writeText(url);
        const original = button.firstChild.textContent;
        button.firstChild.textContent = "Copied ";
        window.setTimeout(() => { button.firstChild.textContent = original; }, 1400);
      }
    });
  });

  page.dataset.journalismReady = "true";
  page.querySelectorAll("[data-journalism-edition-browser]").forEach(initJournalismEditionBrowser);
  show(0);
}

export default function initJournalism(root = document) {
  root.querySelectorAll("[data-journalism-page]").forEach(initJournalismPage);
}
